import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { TipoInventarioService } from 'src/app/services/tipo-inventario.service';
import { ArticuloService } from 'src/app/services/articulo.service'
import { SpinnerService } from 'src/app/services/spinner.service';
import { alertaConfirmacion, alertaConfirmacionHTML, basicAlert, basicAlertHTML, filtrarCoincidenciaArrayTransportista, obtenerFechaActual, obtenerFechaSeleccionada, openDescripcion, openObservacion, openReutilizar, setConfigTable, setConfigTableBuscador, timerOut } from 'src/app/shared/utils';
import { ModalBusquedaProveedorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proveedor/modal-busqueda-proveedor.component'
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { iArticulo } from 'src/app/models/iarticulomodel'
import { ArticuloModel } from 'src/app/models/articulo.model'
import { objArticulo } from 'src/app/models/objarticulo.model'
import { ProveedorService } from 'src/app/services/proveedor.service'
import { UnidadService } from 'src/app/services/unidad.service';
import { RecursosService } from 'src/app/services/recursos.service';
import { isNumber } from 'util';

import { inventariosService } from 'src/app/services/inventarios.service'
import { thresholdSturges } from 'd3';
import { positionElements } from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { ClaseGenericaService } from 'src/app/services/clase-generica.service';
import { AnyMxRecord } from 'dns';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { TipoControlStockService } from 'src/app/services/tipo-control-stock.service';

@Component({
  selector: 'app-md-generar-codigo-art',
  templateUrl: './md-generar-codigo-art.component.html',
  styleUrls: ['./md-generar-codigo-art.component.css']
})
export class MdGenerarCodigoArtComponent implements OnInit {
  @Input() titulo:string;
  @Input() tipinv:any;
  @Input() descri:any;
  valor:any;
  objArticulo:any;
  campos:any []=[];
  
  constructor(
    private toastr: ToastrService,
    private modalService2: NgbActiveModal,
  
    private spinnerService: SpinnerService,
    private recursosService: RecursosService,
    private inventariosService: inventariosService,
    private ClaseGenericaService:ClaseGenericaService,
    private articuloService: ArticuloService) { }
    proveedores: any[] = [];
    public _recursos: any = {};
    public objarticulo = new objArticulo();
    public tiposInventario: any[] = [];
    texto:any;
    separador:any;
    autogenerado:any;
    clase1:any;
    @ViewChild('selectTipoInventario') selectTipoInventario: ElementRef;
    arrpatron:any[]=[null];
    valPatron:any='';
    
    clases:any[]=[];
    descripcion:any;
    claseCodigo:any;
    clasesCodigos:any[]=[];
    claseCod:any;
    posicionClase:any;
    objPatron:any[]=[];
    tamanio=2;
  ngOnInit(): void {
    this.valor=this.tipinv;
    this.spinnerService.activarLoading(true);
    this.recursosService.recursosArticulo().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      this._recursos = resp.body;

      if (this._recursos != null && this._recursos.inventarios != null)
        this.tiposInventario = this._recursos.inventarios;
     

    }, err => {
      this.spinnerService.activarLoading(false);
    });
    this.ClaseGenericaService.busar_clase_articulo(this.tipinv).subscribe((response)=>{
      console.log('clases',response.body);
      this.clases=response.body;
    });
    
    this.inventariosService.obtenerInventario(this.valor).subscribe((response)=>{
        this.objArticulo=response.body;
        this.campos=eval(this.objArticulo.patron);
        for(let i=0;i<this.campos.length;i++){
          let _obj:any={
            _kind: this.campos[i].kind,
            _codeClass:this.campos[i].codeClass,
            _separador: this.campos[i].separator,
            _width: +this.campos[i].width,
            _codigos: [],
            _nomClase:''
         }
          this.objPatron.push(_obj); 
          if(this.campos[i].kind =='Clase'){
            let _clase:any;
            let claseCodigo:any={
              clase:+this.campos[i].codeClass,
              codigo:0
            }
            this.arrCampos.push(claseCodigo);
            _clase=this.campos[i].width;
            this.arrpatron[i]='_'.repeat(_clase);
            this.spinnerService.activarLoading(true);
            this.articuloService.getClaseCodigo(this.tipinv, this.campos[i].codeClass).subscribe((resp: any) => {
              this.spinnerService.activarLoading(false);
              this.clasesCodigos = resp.body;
              _obj._codigos=this.clasesCodigos;
              for(let k=0;k<this.clases.length;k++){
                if(this.clases[k].clase==this.campos[i].codeClass){
                   _obj._nomClase=this.clases[k].descri.toLowerCase();
                }
              }     
            }, err => {
              this.spinnerService.activarLoading(false)
              console.log(err)
            });
          }
          if(this.campos[i].kind =='Autogenerado'){
            let auto:any;
            auto=this.campos[i].width;
            this.arrpatron[i]='0'.repeat(auto);
            _obj._nomClase=this.campos[i].kind.toLowerCase();
            
          }
          if(this.campos[i].kind == 'Texto'){
            let _texto:any;
            _texto=this.campos[i].width;
            this.arrpatron[i]='_'.repeat(_texto);   
            _obj._nomClase=this.campos[i].kind.toLowerCase();
           
          }
          if(this.campos[i].kind == 'Separador'){
            this.arrpatron[i]=this.campos[i].separator;
            _obj._nomClase=this.campos[i].kind.toLowerCase();
            
          }
          }
          this.valPatron=this.arrpatron.join('');
    });
    
  }
  arrCampos:any[]=[];
  actualizarPatronClase(o:any,i:any,tam:any,cla:any,nom:any){
    console.log('o',typeof o);
    if(o!=''){
      console.log('o.length',o.length)
      if (o.length > tam) {
        this.articuloService.getClaseCodigo(this.tipinv, this.campos[i].codeClass).subscribe((resp: any) => {
          this.objPatron[i]._codigos=resp.body;
        });
        basicAlert(`El código de ${nom} debe ser de ${tam} caracteres`, 'warning', 'Aceptar');
        return;
      }
      this.arrpatron[i]=o;
      this.valPatron=this.arrpatron.join('');
      for(let j=0;j<this.arrCampos.length;j++){
        if(this.arrCampos[j].clase==cla){
            this.arrCampos[j].codigo=o;
        }
      }
      console.log('arrCampos',this.arrCampos);
      console.log('nuevoPatron',this.valPatron)
    }else{
      console.log('tam',tam);
      this.arrpatron[i]='_'.repeat(tam); 
      this.valPatron=this.arrpatron.join('');
    }
   
  }
  asd:any;
  actualizarPatronTexto(o:any,i:any,tam:any){
    console.log('o',typeof o);
    if(o!=''){
      console.log('o.length',o.length);
      if (o.length > tam) {
       console.log('Entro en cambio')
        basicAlert('Numero de caracteres incorrecto', 'warning', 'Aceptar');
        this.asd='';
        this.arrpatron[i]='_'.repeat(tam); 
        this.valPatron=this.arrpatron.join('');
        return;
      }
      this.arrpatron[i]=o;
      this.valPatron=this.arrpatron.join('');
      console.log('nuevoPatron',this.valPatron)
    }else{
      console.log('tam',tam);
      this.arrpatron[i]='_'.repeat(tam); 
      this.valPatron=this.arrpatron.join('');
    }
   
  }
   
  _guardar(){
    let objGuardar:any={
      clasCod:this.arrCampos,
      valPa:this.valPatron
    }
    if(objGuardar.valPa.includes('_')){
      basicAlert('Patron Incorrecto', 'warning', 'Aceptar');
      return;
    }else{
      console.log('Se guardo correctamente');
      this.modalService2.close(objGuardar);
    }
   
  }
  _close(){
    this.modalService2.dismiss('canceling');
  }
  cerrar(): void {
    this.modalService2.dismiss('canceling');
  }
   

}
